export default "__VITE_ASSET__BPvkzanD__"